import MAP from './checklistKoEnMap.json';

const HANGUL = /[\uAC00-\uD7A3]/;

export function hasHangul(s) {
  return HANGUL.test(String(s ?? ''));
}

function stripLeadingNumber(s) {
  return String(s || '').replace(/^\d+[.)]\s+/, '').trim();
}

export function translateKo(s) {
  if (s == null || s === '') return s;
  const raw = String(s);
  if (Object.prototype.hasOwnProperty.call(MAP, raw)) return MAP[raw];
  const core = stripLeadingNumber(raw);
  if (core !== raw && Object.prototype.hasOwnProperty.call(MAP, core)) return MAP[core];
  return raw;
}

export function numberedQuestion(text, order, idx) {
  const raw = String(text || '');
  const m = raw.match(/^(\d+)[.)]\s+/);
  let t = translateKo(stripLeadingNumber(raw));
  t = stripLeadingNumber(t);
  let n;
  if (m) {
    n = m[1];
  } else {
    n = Number(order);
    if (!Number.isFinite(n) || n < 1) n = (idx != null ? Number(idx) : 0) + 1;
    if (!Number.isFinite(n) || n < 1) n = 1;
  }
  if (!t) return `${n}.`;
  return `${n}. ${t}`;
}

export function translateItem(item) {
  const src = item || {};
  const questionSrc = src.question || src.inspectionItem || src.text || '';
  const methodSrc = src.method_tool || src.methodTool || '';
  const criteriaSrc =
    src.inspection_criteria || src.regulation_reference || src.standardRef || '';
  const infoSrc = src.instruction || src.info || '';
  return {
    question: numberedQuestion(questionSrc, src.order ?? src.item_order, src.idx),
    inspectionItem: numberedQuestion(src.inspectionItem || questionSrc, src.order ?? src.item_order, src.idx),
    text: numberedQuestion(src.text || questionSrc, src.order ?? src.item_order, src.idx),
    category: translateKo(src.category || ''),
    method_tool: translateKo(methodSrc),
    methodTool: translateKo(src.methodTool || src.method_tool || ''),
    inspection_criteria: translateKo(criteriaSrc),
    regulation_reference: translateKo(
      src.regulation_reference || src.inspection_criteria || src.standardRef || ''
    ),
    standardRef: translateKo(
      src.standardRef || src.inspection_criteria || src.regulation_reference || ''
    ),
    instruction: translateKo(infoSrc),
    info: translateKo(src.info || src.instruction || ''),
  };
}

function blankInfo(s) {
  const t = String(s || '').trim();
  return !t || t === '-' || t === '—';
}

function stripInfoLabel(s) {
  return String(s || '')
    .replace(
      /^(method|pass when|pass-when|when to pass|threshold|how|inspection method|criteria|instruction|info)\s*[:\-–]\s*/i,
      ''
    )
    .replace(/^pass when\s+/i, '')
    .trim();
}

/** One Info block for every question ?? no Method / Pass when labels. */
export function inspectInfoText(item) {
  const src = item || {};
  const parts = [];
  const add = (val) => {
    const v = stripInfoLabel(translateKo(val));
    if (blankInfo(v)) return;
    const lower = v.toLowerCase();
    if (
      parts.some((p) => {
        const pl = p.toLowerCase();
        return pl === lower || pl.includes(lower) || lower.includes(pl);
      })
    )
      return;
    parts.push(v);
  };
  add(src.instruction || src.info || '');
  add(src.method_tool || src.methodTool || '');
  add(src.inspection_criteria || src.regulation_reference || src.standardRef || src.grounds || '');
  if (!blankInfo(src.pass_threshold)) {
    const u = src.unit && src.unit !== '-' && src.unit !== '—' ? ` ${src.unit}` : '';
    add(`${String(src.pass_threshold).trim()}${u}`);
  }
  add(src.description || src.notes || src.comment || '');
  return parts.join('\n\n');
}

export function englishizeItem(it, idx) {
  const t = translateItem({ ...it, idx });
  const q = String(it.question || it.inspectionItem || it.text || '').trim();
  return {
    ...it,
    question: q ? t.question : it.question,
    category: t.category || it.category,
    method_tool: t.method_tool || it.method_tool,
    inspection_criteria: t.inspection_criteria || it.inspection_criteria,
    instruction: t.instruction || it.instruction,
    info: t.info || it.info,
  };
}
